import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Mic, MicOff, PhoneOff, Hash } from 'lucide-react';

const DTMF_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

interface CallControlsProps {
  isMuted: boolean;
  onToggleMute: () => void;
  onHangUp: () => void;
  onSendDigits: (digits: string) => void;
}

export function CallControls({ isMuted, onToggleMute, onHangUp, onSendDigits }: CallControlsProps) {
  const [showKeypad, setShowKeypad] = useState(false);

  return (
    <div className="p-3 space-y-2">
      {/* DTMF Keypad */}
      {showKeypad && (
        <div className="grid grid-cols-3 gap-1 pb-2">
          {DTMF_KEYS.map((key) => (
            <Button
              key={key}
              variant="outline"
              size="sm"
              className="font-mono"
              onClick={() => onSendDigits(key)}
            >
              {key}
            </Button>
          ))}
        </div>
      )}

      {/* Control buttons */}
      <div className="flex items-center justify-center gap-3">
        <Button
          size="icon"
          variant={isMuted ? 'destructive' : 'outline'}
          className="h-12 w-12 rounded-full"
          onClick={onToggleMute}
        >
          {isMuted ? <MicOff className="h-5 w-5" /> : <Mic className="h-5 w-5" />}
        </Button>

        <Button
          size="icon"
          variant="outline"
          className="h-12 w-12 rounded-full"
          onClick={() => setShowKeypad(!showKeypad)}
        >
          <Hash className="h-5 w-5" />
        </Button>

        <Button
          size="icon"
          variant="destructive"
          className="h-12 w-12 rounded-full"
          onClick={onHangUp}
        >
          <PhoneOff className="h-5 w-5" />
        </Button>
      </div>
    </div>
  );
}
